export enum DischargeType {
    ImprovedDischarge = 1,
    HealedDischarge = 2,
    Evasion = 3,
    DischargeOnAbandonment = 4,
    DischargeOnDeath = 5,
    AdministrativeDischarge = 6,
    DischargeByTransfer = 7,
    DischargeOnMedicalAdvice = 8,
    DischargeOnRequest = 9,
};

export const dischargeTypeMessages = {
    [DischargeType.ImprovedDischarge]: "Alta Melhorada",
    [DischargeType.HealedDischarge]: "Alta Curada",
    [DischargeType.Evasion]: "Evasão",
    [DischargeType.DischargeOnAbandonment]: "Alta por Abandono",
    [DischargeType.DischargeOnDeath]: "Alta por Óbito",
    [DischargeType.AdministrativeDischarge]: "Alta Administrativa",
    [DischargeType.DischargeByTransfer]: "Alta por Transferência",
    [DischargeType.DischargeOnMedicalAdvice]: "Alta por Indicação Médica",
    [DischargeType.DischargeOnRequest]: "Alta a Pedido",
};